import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import SideMenuMobileComponent from "./side-menu-mobile/side-menu-mobile-component";
class SideMenuComponent extends PureComponent {
    render() {
        const { isOpen, scrollMode, mobileHeaderLinks } = this.props;
        return /*#__PURE__*/ _jsx(SideMenuMobileComponent, {
            open: isOpen,
            scrollMode: scrollMode,
            mobileHeaderLinks: mobileHeaderLinks
        });
    }
}
export { SideMenuComponent as default };
SideMenuComponent.defaultProps = {
    isOpen: false
};
